import { render } from "./colaboradores.vue?vue&type=template&id=4ad2ce19&scoped=true"
import script from "./colaboradores.vue?vue&type=script&lang=js"
export * from "./colaboradores.vue?vue&type=script&lang=js"

import "./colaboradores.vue?vue&type=style&index=0&id=4ad2ce19&lang=css"
import "./colaboradores.vue?vue&type=style&index=1&id=4ad2ce19&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad2ce19"]])

export default __exports__